/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { motion } from "framer-motion";
// material ui
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
// custom components
import TemplateListItem from "./TemplatesListItem";
import EmptyListing from "../../../shared-components/crud/listing/EmptyListing";

function TemplatesList(props) {
  // templates from listing hook
  const { templates } = props;
  // check if templates is null
  if (!templates) {
    return null;
  }
  // check if the listing returns any results
  if (templates.length === 0) {
    return (
      <EmptyListing resource="templates" />
    );
  }

  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
      className="flex flex-col flex-auto w-full max-h-full py-64"
    >
      {Object.keys(templates).map(key => (
        <div key={key} className="relative">
          <Typography className="grow text-20 font-bold tracking-tight leading-none px-24 sm:px-24" color="text.secondary">
            {key}
          </Typography>
          <Divider className="mt-16 mb-32" />
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1, transition: { delay: 0.2 } }}
            className="flex grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-32 w-full max-h-full my-64 px-24 sm:px-24"
          >
            {templates[key].map(template => (
              <TemplateListItem key={template.id} template={template} />
            ))}
          </motion.div>
        </div>
      ))}
    </motion.div>
  );
}

export default TemplatesList;
